export const PICK_UP_TIME = "Pick-up time";
export const DROP_OFF_TIME = "Drop-off time";
